import { getWithToken, postWithToken, post } from './fetch';
import { getUsertokenFromCookie } from '@shakkerai/util-cookie';
// urls
import urls from './_services.json';
// util
import { getUrl } from './util.js';

/**
 * 请求SKU列表
 * @param {*} params
 * @param {*} options
 * @returns
 */
export async function requestVipPurchaseList(params) {
  const url = getUrl(urls.getPurchaseVipList);
  const { data } = await getWithToken(url, { packageType: 'TRAIN', ...params });

  return data;
}

/**
 * 下单
 * @param {*} params
 * @param {*} options
 * @returns
 */
export async function requestOrderPurchase(params) {
  const url = getUrl(urls.orderPurchase);
  const { data, code, msg } = await postWithToken(url, {
    ...params,
    txnOrderMsg: {
      javaEnabled: window.navigator.javaEnabled(),
      colorDepth: window.screen.colorDepth,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      language: window.navigator.language,
      timeZoneOffset: new Date().getTimezoneOffset().toString(),
      userAgent: window.navigator.userAgent,
    },
  });

  if (code === 0) {
    return data;
  } else {
    throw new Error(msg);
  }
}

/**
 * 同步用户会员信息
 * @returns
 */
export async function syncUserVipInfo() {
  const url = getUrl(urls.userVipAccount);
  const { data, code } = await getWithToken(url, {});

  if (code === 0) {
    return data;
  } else {
    // throw new Error(msg);
  }
}

/**
 * 流模式算力计算
 * @returns
 */
export async function flowCalculatePower(params) {
  if (!params || params.length < 1) return { power: 0 };

  const url = getUrl(urls.flowCalculatePower);

  const paramList = params.map((param) => {
    const _param = {
      ...param,
      source: 3,
    };
    if (!param.checkpointId) {
      _param.checkpointId = 26968;
    }
    return _param;
  });

  const token = getUsertokenFromCookie();

  const { data, code, msg } = await post(url, paramList, {
    token,
  });

  if (code === 0) {
    return data;
  } else {
    return null;
  }
}

/**
 * 算力计算
 * @returns
 */
export async function calculatePower(params) {
  if (!params) return { power: 0 };

  const isComfy = !!params.comfyParams;
  const url = getUrl(isComfy ? urls.calculatePowerComfy : urls.calculatePower);
  const generateParams = isComfy ? params.comfyParams : params;

  if (!params.checkpointId) {
    params.checkpointId = 26968;
  }

  const { data, code, msg } = await postWithToken(url, {
    source: 3, // 固定写死
    ...generateParams,
  });

  if (code === 0) {
    return data;
  } else {
    throw new Error(msg);
  }
}

/**
 * nps策略
 * @returns
 */
export async function checkQuestionnaireCondition() {
  const url = getUrl(urls.getQuestionnaireConfig);

  const response = await postWithToken(url, {
    businessType: 'nps',
    source: 3,
  });

  const data = response.data;

  if (data && data.limitCount > 0 && data.limitCount === data.count) {
    return true;
  }
}

/**
 * 生图任务加速
 * @param {*} taskId
 * @returns
 */
export async function requestAccelerate(taskId) {
  const { data, code } = await postWithToken(getUrl(urls.accelerateTask), {
    generateId: taskId,
  });
  if (code === 0) {
    return data;
  }
}
